import { Address } from 'components/types';
import { ISODateString } from 'types';

export type TransportationMode = 'CAR' | 'BICYCLE' | 'PEDESTRIAN';
export type RouteCalculationType = 'FASTEST' | 'SHORTEST' | 'ECO';

export enum TransportationModeEnum {
  CAR = 'CAR',
  BICYCLE = 'BICYCLE',
  PEDESTRIAN = 'PEDESTRIAN'
}

export type Route = {
  id: number;
  departureAddress: Address;
  destinationAddress: Address;
  distanceInMeters: number;
  travelTimeInSeconds: number;
  lastUpdated: ISODateString;
  transportationMode: TransportationMode;
  routeCalculationType: RouteCalculationType;
};

export type Routes = Route[];
